import styled from 'styled-components/macro';
import { LG } from '@zendeskgarden/react-typography';
import { variables } from 'theme/variables';
import PublicPage from 'components/PublicPages/PublicPage';

const {
  section_padding_sm: sectionPaddingSm,
  custom_light_grey: customLightGrey,
  media_md: mediaMd,
  spacing,
  custom_blue: customBlue,
  public_app_max_width: publicAppMaxWidth,
} = variables;

export const ProductsPage = styled(PublicPage)``;

export const ProductsSection = styled('div')`
  background: ${(props) => {
    if (props.blue) {
      return customBlue;
    }
    if (props.grey) {
      return customLightGrey;
    }
    return `#fff`;
  }};
  padding: 20px 5px;
  min-width: ${(props) => (props.isPreview ? '375px' : null)} @media ${mediaMd} {
    padding: 20px ${spacing};
  }
`;

export const ProductsSectionInner = styled('div')`
  max-width: ${publicAppMaxWidth};
  margin: 0 auto;
  position: relative;

  padding: ${(props) => {
      if (props.webRefactor) {
        return '0px';
      }
      if (props.first) {
        return `${spacing} ${spacing} ${sectionPaddingSm}`;
      }
      return sectionPaddingSm;
    }}
    12px;
  @media ${mediaMd} {
    padding: ${(props) => (props.webRefactor ? '0px' : sectionPaddingSm)} 12px;
  }
`;

export const ProductsSectionHeader = styled(LG)`
  font-size: 20px !important;
`;
